<app-header [isScrolled]="true"></app-header>
<ion-content>
  <div class="header-container">
    <div class="header-section">
      <ion-img class="left" src="./assets/inner/header-left.svg" alt="Header decoration left"></ion-img>
      <ion-img class="right" src="./assets/inner/header-right.svg" alt="Header decoration right"></ion-img>
      <span>Join Satel</span>
      <span>Build the Future</span>
    </div>
    <p>Satel was established in early 2022 by its founders with experience in the real estate field to become one of the most.</p>
  </div>

  <article class="content-wrapper">
    <h2 class="h2">Current Jobs</h2>
    @for (job of jobs; track job._id) {
      <div class="card">
        <div class="card-header">
          <ion-img src="./assets/satel-logo-en.svg" alt="Satel logo"></ion-img>
          <div class="text">
            <h3>{{ job.title }}</h3>
            <div class="job-type">
              <span>{{ job.location }}</span>
              @if (job.salary) {
                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="6" viewBox="0 0 7 6" fill="none">
                  <circle cx="3.1875" cy="3" r="3" fill="#949494"/>
                </svg>
                <span>{{ job.salary }}</span>
              }
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="6" viewBox="0 0 7 6" fill="none">
                <circle cx="3.1875" cy="3" r="3" fill="#949494"/>
              </svg>
              <span>{{ job.type }}</span>
            </div>
          </div>

          <ion-button href="mailto:info@satel.sa" fill="outline">Apply Now</ion-button>
        </div>
        <div class="card-content">
          <p>{{job.description}}</p>

          <div class="tags">
            @for (tag of job.tags; track tag) {
              <span class="item">{{tag}}</span>
            }
          </div>
        </div>

      </div>
    } @empty {
      <div class="no-jobs">
        <p>There are currently no jobs available. Please check back later.</p>
      </div>
    }

  </article>


  <app-footer></app-footer>
</ion-content>
